import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useViewModeStore = create()(
  persist(
    (set) => ({
      viewMode: "week",
      setViewMode: (viewMode) => set({ viewMode }),
    }),
    {
      name: "calendar-view-mode", // Nombre en localStorage
      merge: (persistedState, currentState) => ({
        ...currentState,
        ...persistedState,
        viewMode: persistedState?.viewMode || "day",
      }),
    },
  ),
);
